import type React from 'react';

import { Translate } from '@change-corgi/core-react/i18n';

import { BannerWrapper } from '#src/app/shared/components/banners/layout';
import { useClearedQueryParamValue } from '#src/app/shared/hooks/location';

export const ExpiredSessionBanner: React.FC = () => {
	const expired = useClearedQueryParamValue('expired_session');

	if (!expired) return null;

	return (
		<BannerWrapper className="py-2">
			<Translate value="fe.pages.petition_show.expired_session" />
		</BannerWrapper>
	);
};
